import { useState } from 'react';
import { Ban } from 'lucide-react';
import { adminApi } from '@/api/client';
import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { ReasonModal } from '@/components/ReasonModal';
import { useErrorToast, useToast } from '@/lib/toast';

export function ForceCancelPage() {
  const [runId, setRunId] = useState('');
  const [confirm, setConfirm] = useState(false);
  const onError = useErrorToast();
  const toast = useToast();

  return (
    <>
      <div>
        <h1 className="text-2xl font-semibold">Force-cancel a flow run</h1>
        <p className="text-sm text-muted-foreground">
          Marks the run as <code>CANCELLED</code> in the database. Use only when a run is stuck
          (queue retries exhausted, workflow hung) and the user is blocked.
        </p>
      </div>

      <Card className="max-w-xl">
        <CardHeader>
          <CardTitle>Run id</CardTitle>
          <CardDescription>
            Cancellation is recorded with your reason in the audit log.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid gap-2">
            <Label htmlFor="runId">Flow run id</Label>
            <Input
              id="runId"
              value={runId}
              onChange={(e) => setRunId(e.target.value)}
              placeholder="run_…"
              className="font-mono"
            />
          </div>
        </CardContent>
        <CardFooter>
          <Button variant="destructive" disabled={!runId.trim()} onClick={() => setConfirm(true)}>
            <Ban />
            Force-cancel run
          </Button>
        </CardFooter>
      </Card>

      <ReasonModal
        open={confirm}
        title="Force-cancel this run?"
        description={`Run id: ${runId.trim()}`}
        confirmLabel="Force-cancel"
        confirmKind="destructive"
        onOpenChange={setConfirm}
        onConfirm={async (reason) => {
          try {
            await adminApi.forceCancelRun(runId.trim(), reason);
            toast.success('Cancelled.');
            setRunId('');
          } catch (e) {
            onError(e);
          }
        }}
      />
    </>
  );
}
